import { CLIENT_STATUSES, type ClientStatus } from '@glory/clients/domain';

/** Список клиентов живёт в адресе: фильтр, поиск и открытая карточка — ссылкой можно поделиться. */
export interface ClientsSearch {
  /** Открытая в панели карточка. */
  readonly client?: string | undefined;
  /** «Мои» — где вы ответственный; без значения — «Все». */
  readonly scope?: 'mine' | undefined;
  /** Без значения — потенциальные и клиенты, без архива. */
  readonly status?: ClientStatus | undefined;
  readonly q?: string | undefined;
  /** Открыть «Новый клиент» — команда ⌘K. */
  readonly create?: boolean | undefined;
  /** Открыть «Объединить клиентов» с пустым выбором — команда ⌘K. */
  readonly merge?: boolean | undefined;
}

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

export function parseClientsSearch(search: Record<string, unknown>): ClientsSearch {
  const status = CLIENT_STATUSES.find((s) => s === search.status);
  return {
    client: text(search.client),
    scope: search.scope === 'mine' ? 'mine' : undefined,
    status,
    q: text(search.q),
    create: search.create === true || search.create === 'true' ? true : undefined,
    merge: search.merge === true || search.merge === 'true' ? true : undefined,
  };
}
